<template>
  <scroll-center-dialog v-model="opened" :loading="save_loading" @close="close" @apply="save" :title="form_title" :scrolled="false">
    <v-text-field
        class="mt-4"
        outlined
        ref="new-visitor-last-name"
        v-model="organization.full_name"
        label="Полное наименование организации"
        :error="hasError('full_name')"
        :error-messages="getError('full_name')"
    >
      <template v-slot:label>
        Полное наименование организации <strong class="red--text">*</strong>
      </template>
    </v-text-field>
    <v-text-field
        outlined
        v-model="organization.short_name"
        label="Краткое наименование организации"
        :error="hasError('short_name')"
        :error-messages="getError('short_name')"
    >
      <template v-slot:label>
        Краткое наименование организации <strong class="red--text">*</strong>
      </template>
    </v-text-field>
    <v-text-field
        outlined
        v-model="organization.inn"
        label="ИНН организации"
        maxlength="12"
        :error="hasError('inn')"
        :error-messages="getError('inn')"
    >
      <template v-slot:label>
        ИНН организации <strong class="red--text">*</strong>
      </template>
    </v-text-field>
    <v-text-field
        class="mb-n2"
        outlined
        v-model="organization.legal_address"
        label="Адрес организации"
        :error="hasError('legal_address')"
        :error-messages="getError('legal_address')"
    >
      <template v-slot:label>
        Адрес организации <strong class="red--text">*</strong>
      </template>
    </v-text-field>
  </scroll-center-dialog>
</template>

<script>
import FormErrorsMixin from "@/mixins/FormErrorsMixin"
import {mapActions} from "vuex";
import ScrollCenterDialog from "@/modules/templates/ScrollCenterDialog";
import PaginatedDataMapperMixin from "@/mixins/PaginatedDataMapperMixin";

export default {
  name: "OrganizationsEditDialog",
  props: {
    opened: Boolean,
    edit: Boolean,
    organizationData: Object
  },
  mixins: [FormErrorsMixin, PaginatedDataMapperMixin],
  components: {
    ScrollCenterDialog
  },
  data() {
    return {
      save_loading: false,
      organization_default: {
        full_name: "",
        short_name: "",
        inn: "",
        legal_address: ""
      },
      organization: undefined
    }
  },
  computed: {
    form_title() {
      return this.edit === false ? "Добавить организацию" : "Редактировать организацию"
    }
  },
  methods: {
    ...mapActions({
      createOrganizations: "admin/createOrganizations",
      changeOrganizations: "admin/changeOrganizations"
    }),
    close(){
      this.$emit("close", false)
    },
    loadOrganizationsData(){
      if(this.organizationData === undefined){
        this.organization = this.organization_default
      }
      else{
        this.organization = JSON.parse(JSON.stringify(this.organizationData))
      }
    },
    save(){
      this.save_loading = true
      if (this.edit) {
        this.changeOrganizations({
          id: this.organization.id,
          data: {
            full_name: this.organization.full_name,
            short_name: this.organization.short_name,
            inn: this.organization.inn,
            legal_address: this.organization.legal_address
          },
          finalizer: (val) => {
            this.$emit("close", this.organization)
            this.save_loading = false
          },
          catcher:(val) => {
            this.mapErrors(val)
            this.save_loading = false
          }
        })
      }else {
        this.createOrganizations({
          data: this.organization,
          finalizer: (val) => {
            this.$emit("close", this.organization)
            this.save_loading = false
          },
          catcher:(val) => {
            this.mapErrors(val)
            this.save_loading = false
          }
        })
      }
    }
  },
  created() {
    this.loadOrganizationsData()
  }
}
</script>

<style scoped>

</style>
